<template>
    <div>
        <el-row>
            <el-col justify="center">
                <h3 class="font_family m-b-20">ҮЙЛЧИЛГЭЭНИЙ НӨХЦӨЛ</h3>
            </el-col>
            <el-col class="m-b-20" :offset="2" :span="20">
                <div class="font_family">
                    Хэрэглэгч нь skycargo.mn веб сайтад хандсан үеэс эхлэн Үйлчилгээний нөхцөлийг хүлээн зөвшөөрсөнд тооцно.
                </div>
            </el-col>
            <el-col :span="20" :offset="2">
                <el-collapse>
                    <el-collapse-item title="ЕРӨНХИЙ"><br>
                        <p><span class="number">1.1.</span> Энэхүү журмаар ТЭНГЭР КАРГО -н (цаашид САЙТ гэнэ) ачаа тээврийн үйлчилгээ, түүнтэй холбоотой үүсэх бүх төрлийн харилцааг зохицуулна.</p>
                        <p><span class="number">1.2.</span> САЙТ нь БНХАУ-д байрлалтай онлайн болон онлайн бус дэлгүүр, нийлүүлэгчээс (цаашид бараа захиалгын аппликэйшн гэх) хэрэглэгчийн сонгон захиалсан бараа бүтээгдэхүүнийг Эрээн дэх агуулахад хүлээн авч тээвэрлэх, нийлүүлэх үйлчилгээ үзүүлнэ.</p>
                        <p><span class="number">1.3.</span> Энэхүү журмын хэрэгжилтэд САЙТ болон хэрэглэгч хамтран хяналт тавина.</p>
                    </el-collapse-item>
                    <el-collapse-item title="ТАНЫ БҮРТГЭЛ"><br>
                        <p><span class="number">2.1.</span> Хэрэглэгч Тэнгэр карго үйлчилгээг ашиглахын тулд өөрийн байнга ашигладаг гар утасны дугаарыг ашиглан хэрэглэгчээр бүртгүүлж, бүртгэл амжилттай болсны дараа өөрийн хувийн мэдээллийг үнэн зөв оруулах шаардлагатай.</p>
                        <p><span class="number">2.2.</span> Та өөрийн бүртгэл, нууц үгийн аюулгүй байдлыг хангах үүрэгтэй бөгөөд таны бүртгэлээс хийгдсэн аливаа үйлдлийг хэрэглэгч өөрөө бүрэн хариуцна.</p>
                    </el-collapse-item>
                    <el-collapse-item title="ЗАХИАЛГА"><br>
                        <span class="text_justify">
                            Хэрэглэгч Тэнгэр карго-н Эрээн дэх агуулахын хаягийг БНХАУ-н бараа захиалгын аппликэйшний хүргэлтийн хаяг хэсэгт холбож тохируулах ба Эрээн агуулахын хаяг зөв холбогдсон эсэхийг Тэнгэр карго фэйсбүүк хуудасны мессеж хэсгээр явуулж, шалгуулна. Эрээн агуулахын хаягаа буруу холбосон, зохих журмаар шалгуулаагүйгээс үүсэх хариуцлагыг Тэнгэр карго хүлээхгүй.<br>
                            Ачаа нь түүвэр ачаа болон овортой ачаа гэсэн төрөлд хуваагдана. Түүвэр ачаанд 1 м.куб хүртэлх ачаа, овортой ачаанд 1 м.куб-с дээш ачаа хамаарна. Хэрэглэгч түүвэр ачааны захиалга хийхдээ Тэнгэр карго-нд урьдчилан мэдэгдэх шаардлагагүй. Овортой ачааны захиалга хийх хэрэглэгч tengerb2b@gmail.com хаягаар холбогдож ачаа тээврийн урьдчилсан үнийн санал авах шаардлагатай.<br>
                            <p><span class="number">3.1.</span> САЙТ нь хэрэглэгчийн БНХАУ-д үйл ажиллагаа эрхэлдэг онлайн болон онлайн бус дэлгүүрүүд, нийлүүлэгчдээс сонгон захиалсан бараа бүтээгдэхүүнийг (цаашид ачаа гэх) Эрээн дэх агуулахад хүлээн авч, тээвэрлэх үйлчилгээ үзүүлнэ.</p>
                            <p><span class="number">3.2.</span> Ачаа тээврийн үйлчилгээ нь хэрэглэгч захиалга өгснөөс эхлэн тээвэрлэлт, барааг хүлээлгэн өгөх хүртэлх бүх үйл явцыг хамрах ба www.skycargo.mn системээр удирдагдана.</p>
                        </span>
                    </el-collapse-item>
                    <el-collapse-item title="ТРАК КОД БҮРТГЭХ, АЧААНЫ ТӨЛӨВ ШАЛГАХ"><br>
                        <p><span class="number">4.1.</span> Хэрэглэгч захиалсан ачааныхаа БНХАУ доторх хүргэлтийн төлөвийг бараа захиалгын аппликэйшнээс болон бараа нийлүүлсэн талаас хянаж, ачааны хяналтын дугаар буюу трак кодыг (цаашид трак код гэх) www.skycargo.mn сайтын трак код бүртгэх хэсэгт бүртгэх үүрэгтэй.</p>
                        <p><span class="number">4.2.</span> Хэрэглэгч ачааны дараах төлөвүүдийг САЙТ-ын миний бүртгэл хэсгээс хянах боломжтой. Үүнд:</p>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Хэрэглэгч бүртгэсэн<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Эрээн дах агуулахаас гарсан<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Монгол дах салбар хүлээн авсан<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Хэрэглэгч хүлээн авсан<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Хэрэглэгч хүргэлтээр авна<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Хэрэглэгч салбараас очиж авна<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Хэрэглэгч салбар дээр хадгалуулна<br>
                    </el-collapse-item>
                    <el-collapse-item title="ТЭЭВЭРЛЭЛТ"><br>
                        <p><span class="number">5.1.</span> Тээвэрлэлт нь БНХАУ дахь хүргэлт, БНХАУ-аас Монгол хүртэлх тээвэрлэлт гэсэн 2 үндсэн үе шатаас бүрдэнэ.</p>
                        <p><span class="number">5.2.</span> БНХАУ дахь хүргэлт нь тухайн дэлгүүр, нийлүүлэгчийн ашиглаж буй дотоодын хүргэлтийн үйлчилгээгээр хийгдэх ба энэ хэсгийг нийлүүлэгч бүрэн хариуцна. Нийлүүлэгчээс болон БНХАУ доторх хүргэлтийн үйлчилгээний алдаанаас шалтгаалан ачаа Эрээн агуулахад хүргэгдээгүй бол Тэнгэр карго хариуцлага хүлээхгүй.</p>
                        <p><span class="number">5.3.</span> Бараа бүтээгдэхүүн Тэнгэр карго-н БНХАУ, Эрээн хот дахь агуулахад хүргэгдэн, Монгол улсруу ачигдсанаас хойш хэвийн ажиллагаатай үед энгийн тээвэр (Тэнгэр карго) дунджаар 4-10 хоног, шуурхай тээвэр (Тэнгэр экспресс) дунджаар 2-3 хоног дотор Монгол дах салбарт бууж бүртгэлд орно. Бүх нийтийн баяр ёслол, гэнэтийн давагдашгүй хүчин үйл үүссэн тохиолдолд тодорхой болон тодорхойгүй хугацаагаар сунгагдаж болно. Гэнэтийн болон давагдашгүй хүчин зүйл гэдэгт гал түймэр, газар хөдлөлт, салхи шуурга, аянга цахилгаан, үер усны гамшиг, нийтийг хамарсан үймээн самуун, эмх замбараагүй байдал, ажил хаялт, эрчим хүчний тасалдал, эсэргүүцлийн хөдөлгөөн, гоц халдварт өвчин, дайн, террорист халдлага, төрийн эрх бүхий байгууллагын шийдвэр, хорио, цээр зэрэг талуудын хүсэл зоригоос үл хамаарах шалтгаанууд багтана.</p>
                    </el-collapse-item>
                    <el-collapse-item title="ҮНЭ, ТӨЛБӨР"><br>
                        <p><span class="number">6.1.</span> Ачаа тээврийн үнэд БНХАУ-с Монгол руу тээвэрлэсэн тээврийн зардал багтах бөгөөд ачаа Монгол дах салбарт ирсэний дараа сайтын үнэ тооцоолох систем бодит жин болон овор хэмжээгээр нь автоматаар тооцоолон гаргана. Ингэхдээ дараах үнийн тарифыг баримтлан тооцоолно. Үүнд:</p><br>
                        <p><span class="number"><u>6.1.1.</u></span><u>Энгийн тээвэр (Тэнгэр карго) – 1кг 3,000₮</u></p><br>
                        <table border="1" cellspacing="0" cellpadding="5">
                            <thead>
                                <tr>
                                <th>Ачааны төрөл</th>
                                <th>Хэмжээ</th>
                                <th>Үнэ (төгрөг)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td rowspan="21">Жижиг ууттай ачаа (1кг - 3,000₮ хүртэл)</td>
                                    <td>0-150гр</td>
                                    <td>2,000</td>
                                </tr>
                                <tr>
                                    <td>151-1000гр</td>
                                    <td>3,000</td>
                                </tr>
                                <tr>
                                    <td>1001-2000гр</td>
                                    <td>6,000</td>
                                </tr>
                                <tr>
                                    <td>2001-3000гр</td>
                                    <td>9,000</td>
                                </tr>
                                <tr>
                                    <td>3001-4000гр</td>
                                    <td>12,000</td>
                                </tr>
                                <tr>
                                    <td>4001-5000гр</td>
                                    <td>13,000</td>
                                </tr>
                                <tr>
                                    <td>5001-6000гр</td>
                                    <td>15,000</td>
                                </tr>
                                <tr>
                                    <td>6001-7000гр</td>
                                    <td>16,500</td>
                                </tr>
                                <tr>
                                    <td>7001-8000гр</td>
                                    <td>18,000</td>
                                </tr>
                                <tr>
                                    <td>8001-9000гр</td>
                                    <td>19,500</td>
                                </tr>
                                <tr>
                                    <td>9001-10000гр</td>
                                    <td>21,000</td>
                                </tr>
                                <tr>
                                    <td>10001-11000гр</td>
                                    <td>22,500</td>
                                </tr>
                                <tr>
                                    <td>11001-12000гр</td>
                                    <td>24,000</td>
                                </tr>
                                <tr>
                                    <td>12001-13000гр</td>
                                    <td>25,500</td>
                                </tr>
                                <tr>
                                    <td>13001-14000гр</td>
                                    <td>27,000</td>
                                </tr>
                                <tr>
                                    <td>14001-15000гр</td>
                                    <td>28,000</td>
                                </tr>
                                <tr>
                                    <td>15001-16000гр</td>
                                    <td>30,000</td>
                                </tr>
                                <tr>
                                    <td>16001-17000гр</td>
                                    <td>31,500</td>
                                </tr>
                                <tr>
                                    <td>17001-18000гр</td>
                                    <td>33,000</td>
                                </tr>
                                <tr>
                                    <td>18001-19000гр</td>
                                    <td>34,500</td>
                                </tr>
                                <tr>
                                    <td>19001-20000гр</td>
                                    <td>36,000</td>
                                </tr>
                                <tr>
                                    <td rowspan="23">Жижиг хайрцагтай ачаа (1кг - 3,500₮ хүртэл)</td>
                                    <td>0-100гр</td>
                                    <td>2,000</td>
                                </tr>
                                <tr>
                                    <td>101-250гр</td>
                                    <td>2,500</td>
                                </tr>
                                <tr>
                                    <td>251-1000гр</td>
                                    <td>3,500</td>
                                </tr>
                                <tr>
                                    <td>1001-2000гр</td>
                                    <td>7,000</td>
                                </tr>
                                <tr>
                                    <td>2001-3000гр</td>
                                    <td>10,500</td>
                                </tr>
                                <tr>
                                    <td>3001-4000гр</td>
                                    <td>14,000</td>
                                </tr>
                                <tr>
                                    <td>4001-5000гр</td>
                                    <td>16,000</td>
                                </tr>
                                <tr>
                                    <td>5001-6000гр</td>
                                    <td>18,000</td>
                                </tr>
                                <tr>
                                    <td>6001-7000гр</td>
                                    <td>20,000</td>
                                </tr>
                                <tr>
                                    <td>7001-8000гр</td>
                                    <td>22,000</td>
                                </tr>
                                <tr>
                                    <td>8001-9000гр</td>
                                    <td>24,000</td>
                                </tr>
                                <tr>
                                    <td>9001-10000гр</td>
                                    <td>26,000</td>
                                </tr>
                                <tr>
                                    <td>10001-11000гр</td>
                                    <td>28,000</td>
                                </tr>
                                <tr>
                                    <td>11001-12000гр</td>
                                    <td>30,000</td>
                                </tr>
                                <tr>
                                    <td>12001-13000гр</td>
                                    <td>32,000</td>
                                </tr>
                                <tr>
                                    <td>13001-14000гр</td>
                                    <td>34,000</td>
                                </tr>
                                <tr>
                                    <td>14001-15000гр</td>
                                    <td>36,000</td>
                                </tr>
                                <tr>
                                    <td>15001-16000гр</td>
                                    <td>38,000</td>
                                </tr>
                                <tr>
                                    <td>16001-17000гр</td>
                                    <td>40,000</td>
                                </tr>
                                <tr>
                                    <td>17001-18000гр</td>
                                    <td>42,000</td>
                                </tr>
                                <tr>
                                    <td>18001-19000гр</td>
                                    <td>44,000</td>
                                </tr>
                                <tr>
                                    <td>19001-20000гр</td>
                                    <td>46,000</td>
                                </tr>
                                <tr>
                                    <td rowspan="23">Овортой хөнгөн ачаа (ууттай ноосон цамц, куртик, хөнжил, гутлын хайрцаг, овортой хөнгөн хайрцаг гэх мэт)</td>
                                </tr>
                                <tr>
                                    <td>жижиг</td>
                                    <td>4,500</td>
                                </tr>
                                <tr>
                                    <td>дунд</td>
                                    <td>6,500</td>
                                </tr>
                                <tr>
                                    <td>том</td>
                                    <td>8,500</td>
                                </tr>
                                <tr>
                                    <td>маш том</td>
                                    <td>10,500</td>
                                </tr>
                            </tbody>
                        </table><br>
                        <p><span class="number"><u>6.1.2.</u></span><u>Энгийн том ачаа (Тэнгэр карго) – 1 м.куб 800юань (Юанийн ханш тухайн өдрийн ханшаар бодогдоно)</u></p><br>
                        <table border="1" cellspacing="0" cellpadding="5">
                            <thead>
                                <tr>
                                <th>Ачааны төрөл</th>
                                <th>Хэмжээ</th>
                                <th>Үнэ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Энгийн, хөнгөн  том ачаа (эзэлхүүнээр)</td>
                                    <td>1 м.куб</td>
                                    <td>800 юань*</td>
                                </tr>
                                <tr>
                                    <td rowspan="2">Хүнд том ачаа (эзэлхүүн, жинг харьцуулан тооцно)</td>
                                    <td>1кг (20кг-с дээш)</td>
                                    <td>1,750₮</td>
                                </tr>
                                <tr>
                                    <td>1 м.куб</td>
                                    <td>900-1000 юань*</td>
                                </tr>
                            </tbody>
                        </table><br>
                        <p><span class="number"><u>6.1.3.</u></span><u>1м.куб-с дээш том ачаа (Тэнгэр карго) – Урьдчилан үнийн санал авна.</u></p>
                        <p>Хэрэглэгч 1 м.куб-с дээш хэмжээтэй ачаа захиалах бол tengerb2b@gmail.com хаягаар ачааны урт, өргөн, өндөр, жин, үзүүлэлтийн мэдээллийг дэлгэрэнгүй явуулж, ачаа тээврийн урьдчилсан үнийн санал авна.</p><br>
                        <p><span class="number"><u>6.1.4.</u></span><u>Шуурхай жижиг ачаа (Тэнгэр экспресс) – 1кг 5,000₮</u></p><br>
                        <table border="1" cellspacing="0" cellpadding="5">
                            <thead>
                                <tr>
                                <th>Ачааны төрөл</th>
                                <th>Хэмжээ</th>
                                <th>Үнэ (төгрөг)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td rowspan="11">Экспресс жижиг ууттай, хайрцагтай ачаа (1кг 5,000₮ хүртэл)</td>
                                    <td>0-200гр</td>
                                    <td>4,000</td>
                                </tr>
                                <tr>
                                    <td>201-1000гр</td>
                                    <td>5,000</td>
                                </tr>
                                <tr>
                                    <td>1001-2000гр</td>
                                    <td>10,000</td>
                                </tr>
                                <tr>
                                    <td>2001-3000гр</td>
                                    <td>15,000</td>
                                </tr>
                                <tr>
                                    <td>3001-4000гр</td>
                                    <td>20,000</td>
                                </tr>
                                <tr>
                                    <td>4001-5000гр</td>
                                    <td>22,000</td>
                                </tr>
                                <tr>
                                    <td>5001-6000гр</td>
                                    <td>24,000</td>
                                </tr>
                                <tr>
                                    <td>6001-7000гр</td>
                                    <td>26,000</td>
                                </tr>
                                <tr>
                                    <td>7001-8000гр</td>
                                    <td>28,000</td>
                                </tr>
                                <tr>
                                    <td>8001-9000гр</td>
                                    <td>30,000</td>
                                </tr>
                                <tr>
                                    <td>9001-10000гр</td>
                                    <td>32,000</td>
                                </tr>
                                <tr>
                                    <td rowspan="23">Экспресс овортой хөнгөн ачаа (ууттай ноосон цамц, куртик, хөнжил, гутлын хайрцаг, овортой хөнгөн хайрцаг гэх мэт)</td>
                                    <td>жижиг</td>
                                    <td>7,000</td>
                                </tr>
                                <tr>
                                    <td>дунд</td>
                                    <td>10,000</td>
                                </tr>
                                <tr>
                                    <td>том</td>
                                    <td>13,000</td>
                                </tr>
                                <tr>
                                    <td>маш том</td>
                                    <td>16,000</td>
                                </tr>
                            </tbody>
                        </table><br>
                        <p style="color: red;">Шуурхай тээврээр том ачаа хүлээн авах боломжгүй.</p><br>
                        <p><span class="number">6.2.</span> Хэрэглэгчийн захиалсан ачаанд Монгол улсын хуулийн дагуу гаалийн болон бусад татвар ноогдуулах тохиолдолд ачаа тээврийн үнэ дээр нэмж тооцоолно.</p>
                        <p><span class="number">6.3.</span> Хэрэглэгч ачаа тээврийн үнийг 100 хувь төлснөөр хэрэглэгчид ачааг хүлээлгэн өгнө.</p>
                        <p><span class="number">6.4.</span> Ачаа тээврийн үнэ автоматаар MNT (төгрөг)-р бодогдох бөгөөд систем хөрвүүлэхдээ тухайн өдрийн CNY зарах ханшаар тооцон хөрвүүлнэ.</p>
                        <p><span class="number">6.5.</span> Төлбөрийг веб сайт дээрх төлбөр төлөх төгрөгийн дансаар болон салбарт бэлэн мөнгөөр, картаар төлнө.</p>
                    </el-collapse-item>
                    <el-collapse-item title="АЧАА ОЛГОЛТ"><br>
                        <p><span class="number">7.1.</span> Хэрэглэгч Монголд ирсэн ачаагаа Тэнгэр карго салбаруудаас өөрийн биеэр ирж авах боломжтой. Салбаруудын хаяг байршил, цагийн хуваарь, холбогдох утасны дугаарын мэдээллийг www.skycargo.mn вэб сайтад байршуулна.</p>
                        <p><span class="number">7.2.</span> Тээврийн зардлыг хэрэглэгч 100% төлсөн тохиолдолд ачааг олгоно.</p>
                        <p><span class="number">7.3.</span> Ачааг хэрэглэгчид олгох үед хэрэглэгч бараа бүтээгдэхүүнийг сайтар шалган, эвдрэл гэмтлийг нягтлан үзсэний үндсэн дээр хүлээн авна. Ачааг хэрэглэгч хүлээн авснаас хойш гарсан эвдрэл гэмтэл болон бусад асуудлуудад САЙТ хариуцлага хүлээхгүй.</p>
                        <p><span class="number">7.4.</span> Салбараас ачаа авахаар ирсэн хэрэглэгч нь өндөр настан, хөгжлийн бэрхшээлтэй иргэн, жирэмсэн, нялх хүүхэдтэй зэрэг хүндэтгэх шалтгаантайгаас бусад тохиолдолд салбарын ажилтан ачаа барааг салбарын байрнаас гаргаж, машинд ачиж өгөх үйлчилгээ үзүүлэхгүй.</p>
                    </el-collapse-item>
                    <el-collapse-item title="ХҮРГЭЛТ"><br>
                        <p><span class="number">8.1.</span> САЙТ хэрэглэгчийн хүсэлд нийцүүлэн нийслэл хот, хөдөө орон нутгийн унаанд ачааг хүргэх үйлчилгээ үзүүлнэ.</p>
                        <p><span class="number">8.2.</span> Хүргэлтийн үйлчилгээ авах хэрэглэгч ачаа Монгол дах салбарт ирсэний дараа www.skycargo.mn сайтаар хүргэлтийн захиалга хийнэ. Хүргэлтийн захиалга хийх заавар: <a href="https://www.facebook.com/share/r/16UawFG1i5/?mibextid=wwXIfr"  style="color: blue;" target="_blank">https://www.facebook.com/share/r/16UawFG1i5/?mibextid=wwXIfr                        </a></p>
                        <p><span class="number">8.3.</span> Тухайн АЖЛЫН ӨДРИЙН 15:00 цагаас өмнө ирсэн хүргэлтийн захиалгын ачаа тээврийн болон хүргэлтийн төлбөр тооцоо тухайн ажлын өдрийн 17:00 цагийн дотор 100% төлөгдсөн тохиолдолд салбараас ачааг бэлдэж хүргэлтийн компанид хүлээлгэн өгнө. </p>
                        <p><span class="number">8.4.</span> Ачааг хүргэлтийн компанид хүлээлгэн өгснөөс хойш хүргэлтийн төлөвийг 7200-7210 утасны дугаараар лавлах боломжтой ба 24-48 цагийн дотор хэрэглэгчийн мэдэгдсэн хаягаар хүргэгдэнэ.</p>
                        <p><span class="number">8.5.</span> Хүргүүлэх ачааны жин, овор хэмжээнээс хамааран хүргэлтийн үнэ тогтоогдож, ачаа тээврийн төлбөр дээр нэмж тооцогдоно. Үүнд:</p><br>
                        <table border="1" cellspacing="0" cellpadding="5">
                            <thead>
                                <tr>
                                    <th>Овор хэмжээ</th>
                                    <th>Жин</th>
                                    <th>Хүргэлтийн үнэ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>60смX60смX60см-с доош</td>
                                    <td>10кг-с доош</td>
                                    <td>7,000₮</td>
                                </tr>
                                <tr>
                                    <td>60смХ60смХ60см-с 80смХ80смХ80см</td>
                                    <td>10кг-с 15кг</td>
                                    <td>12,000₮</td>
                                </tr>
                                <tr>
                                    <td>80смХ80смХ80см-с 1мХ1мХ1м</td>
                                    <td>15кг-с 20кг</td>
                                    <td>20,000₮</td>
                                </tr>
                                <tr>
                                    <td>1мХ1мХ1м-с дээш</td>
                                    <td>20кг-с дээш</td>
                                    <td>30,000₮</td>
                                </tr>
                            </tbody>
                        </table><br>
                        <p><span class="number">8.6.</span> Улаанбаатар хот доторх хүргэлтийн бүсээс хэтэрсэн тохиолдолд дээрх тариф дээр нэмж тооцогдох боломжтой. Хүргэлтийн бүс Тахилт, Баянхошуу, 7 буудал, Шар хад, Амгалан, Зайсан, Буянт ухаа 2 бүсээр хязгаарлагдана.</p>
                        <p><span class="number">8.7.</span> Орон нутгийн унаанд тавих төлбөр нь хот доторх тээврийн үнэтэй ижил байна. Орон нутгийн унааны ачаа тээврийн төлбөрийг хэрэглэгч бүрэн хариуцна.</p>
                    </el-collapse-item>
                    <el-collapse-item title="АЧАА ХАДГАЛАЛТ"><br>
                        <p><span class="number">9.1.</span> Ачаа Монголд ирсэнээс хойш 10 хоног хүртэл Тэнгэр карго салбарт үнэгүй хадгална.</p>
                        <p><span class="number">9.2.</span> Ачаа Монголд ирсэнээс хойш 10-с дээш хоног хадгалагдах тохиолдолд дараах байдлаар алданги тооцно. Үүнд:</p>
                        <p><span class="number">&nbsp;&nbsp;<u>9.2.1.</u></span> &nbsp;&nbsp;Бүртгэлтэй ирсэн ачаа: Хэрэглэгчийн бүртгэлтэй утасны дугаар луу ачаагаа ирж авах талаар сануулсан, хадгалалтын төлбөр тооцох талаар мэдээлэл өгсөн боловч Монгол дах салбарт ирсэнээс хойш 10 хоногийн дотор ирж аваагүй бол тухайн ачааны тээврийн үнийн дүнгийн 10 хувиар хоног тутамд хадгалалтын төлбөр тооцох болно.</p>
                        <p><span class="number">&nbsp;&nbsp;<u>9.2.2.</u></span> &nbsp;&nbsp;Бүртгэлгүй ирсэн бараа: Бүртгэлтэй хэрэглэгчийн мэдээлэл огт байхгүй, ямар ч холбоо барих боломжгүйгээс үүдэн хадагалах хугацаа хэтрүүлсэн ачаа бол нийт тээврийн үнийн дүнгийн 1 хувиар хоног тутамд хадгалалтын төлбөр тооцох болно.</p>
                    </el-collapse-item>
                    <el-collapse-item title="ТРАК КОДООР БҮРТГЭГДСЭН АЧАА"><br>
                        <p><span class="number">10.1.</span> Ачаан дээр хэрэглэгчийн утасны дугаар хэвлэгдээгүй, хэрэглэгч захиалсан ачааныхаа трак кодыг www.skycargo.mn сайтад бүртгээгүй ачааг системд зөвхөн ачааны трак кодоор бүртгэнэ. Энэ төрлийн ачааг сайтнаас трак кодоор хайж, шалгах боломжтой.</p>
                        <p><span class="number">10.2.</span> Сайтад зөвхөн трак кодоор бүртгэгдсэн ачааг хэрэглэгчид олгохдоо бараа захиалгын аппликэйшнээс захиалсан хуудас болон ачааны трак кодыг тулгаж, шалгасны үндсэн дээр хүлээлгэн өгнө.</p>
                    </el-collapse-item>
                    <el-collapse-item title="БҮРТГЭЛД ОРООГҮЙ АЧАА"><br>
                        <p><span class="number">11.1.</span> Та Тэнгэр карго Эрээн агуулахын хаяг дээр захиалсан, дараах шалгуурыг хангасан ачааг шалгуулах боломжтой. Үүнд:</p>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - Бараа захиалгын аппликэйшн дээр Эрээнд очсон ч www.skycargo.mn системд 3 хоногийн дотор Эрээн агуулах хүлээн авсан төлөвт ороогүй (Бараа захиалгын аппликэйшн дээр Эрээнд очсон ачааг цуглуулах цэгээс татан авч, Эрээн агуулахад бүртгэлд оруулан Монгол руу ачуулах хүртэл хамгийн дээд хугацаа 3 хонох боломжтой)</p>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - Эрээн агуулахад хүлээн авсан төлөвт орсоноос хойш экспресс тээврийн хувьд 5 хоног, энгийн тээврийн хувьд 14 хоногийн дотор Монгол дах салбарт бүртгэгдээгүй (Таны ачааг Эрээн агуулахаас Монгол руу тээвэрлэх хугацаа нь ачаа тээвэр хэвийн ачаалалтай үед экспресс тээвэр 2-3 хоног, энгийн тээвэр 4-10 хоног байна)</p>
                        <p><b>Та дээрх шалгуурыг хангасан ачааг шалгуулах бол www.skycargo.mn хэрэглэгчийн бүртгэлээр нэвтэрч ороод шалгуулах ачааны трак кодыг бүртгүүлэн “Трак код шалгуулах” хүсэлт илгээнэ.</b></p>
                        <p><span class="number">11.2.</span> Бүртгэлд ороогүй ачааг Эрээн салбарт хүлээн авсан эсэх, ямар шалтгааны улмаас хугацаандаа ирээгүй талаар шалгаж, хэрэглэгч шалгуулснаас хойш 7 хоногийн дотор эргэн хариу өгнө.</p>
                        <p><span class="number">11.3.</span> Бүртгэлд ороогүй ачааг шалгуулах хүсэлт илгээснээс хойш 10 хоногийн дотор шийдвэрлэгдээгүй тохиолдолд хэрэглэгчээс ачаа захиалсан захиалгын хуудсыг авч, ачааны үнийг төлж шийдвэрлэнэ. Энэ тохиолдолд тухайн өдрийн CNY (юань) ханшаар хөрвүүлэн MNT (төгрөг)-өөр төлбөр тооцоог хийнэ.</p>
                    </el-collapse-item>
                    <el-collapse-item title="ХОРИОТОЙ БОЛОН ТУСГАЙ ЗӨВШӨӨРӨЛТЭЙ БАРАА"><br>
                        <p><span class="number">12.1.</span> <span style="color: red;">‼‼ Каргогоор тээвэрлэхэд тохиромжгүй доорх төрлийн ачааг Эрээн агуулахад хүлээж авахгүй болохыг анхаарна уу ‼‼</span> Үүнд:</p>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Амархан хагарч эвдрэх зүйлс (шил, шилэн нүүртэй эдлэл, шилэн савалгаатай гоо сайхны бүтээгдэхүүн, шаазан, толь, ваар, хуванцар, чулуун тавцан г.м)<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Доргилтонд гэмтэх магадлалтай технологийн бүтээгдэхүүн (компьютер, таблет, түүний эд анги, дэлгэц, телевизор г.м)<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Хэт том овортой зүйлс (буйдан, тавилга, үйлдвэрлэлийн тоног төхөөрөмж г.м)<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Хэт өндөр үнэтэй, жижиг овортой зүйлс (Үнэт эдлэл, чип, гар утас, технологийн бүтээгдэхүүн г.м)<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Бүх төрлийн хүнсний бүтээгдэхүүн (жимс жимсгэнэ, чихэр, хадгалалтын горим алдагдах зүйлс г.м)<br>
                        <p><span class="number">12.2.</span> <span style="color: red;">‼‼ Монгол улсын хуулийн дагуу гаалиар нэвтрүүлэхийг хориглосон бүх төрлийн бараа бүтээгдэхүүнийг тээвэрлэх боломжгүй  ‼‼</span> Үүнд:</p>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Согтууруулах ундаа<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Тамхи<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Стратегийн хүнс<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Жижиглэн савалгаатай, 25%-с дээш концентрацитай, хүнсний зориулалттай цууны хүчил<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Зохих зөвшөөрөлгүй хүний болон малын эм, эмийн бүтээгдэхүүн, эмнэлгийн хэрэгсэл<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Тэсэрч дэлбэрэх бодис, тэсэлгээний хэрэгсэл, түүхий эд<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Мод, сөөгний тарьц, суулгац<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Мал, амьтан<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Химийн хорт бодис<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Мансууруулах болон сэтгэцэд нөлөөт бодис<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Аюултай хог хаягдал<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Асбест агуулсан тоормозны накладка<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Цөмийн бодис<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Галт зэвсэг, сум, галт зэвсэгтэй адилтгах хэрэгсэл<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Бүх төрлийн шатахуун<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Пиротехникийн хэрэгсэл<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp; Хууль тогтоомжоор хориглосон бусад зүйл<br>
                        <p><span class="number">12.3.</span> Тусгай зөвшөөрлийн лиценз шаарддаг бараа бүтээгдэхүүн захиалах тохиолдолд хэрэглэгч тухайн бүтээгдэхүүний тусгай зөвшөөрлийн лицензтэй бол САЙТ-аар Монгол улсын гааль хүртэлх гүйцэтгэлийг гүйцэтгүүлж болно.</p>
                    </el-collapse-item>
                    <el-collapse-item title="ҮЙЛЧИЛГЭЭ ҮЗҮҮЛЭХЭЭС ТАТГАЛЗАХ НӨХЦӨЛ"><br>
                        Хэрэглэгчийн зүгээс дараах нөхцөл байдлыг үүсгэсэн тохиолдолд САЙТ хэрэглэгчид үйлчилгээ үзүүлэхээс татгалзах, хэрэглэгчийн нэвтрэх эрхийг хязгаарлах эрхтэй. Үүнд:<br>
                        <p><span class="number">13.1.</span> Хэрэглэгч үндэслэлгүй гомдол 3 ба түүнээс дээш удаа гаргаж, үйл ажиллагаанд саад учруулсан</p>
                        <p><span class="number">13.2.</span> Хэрэглэгч харилцааны доголдол гаргасан, ажилтныг илт доромжилсон, ажилд саад болсон</p>
                    </el-collapse-item>
                    <el-collapse-item title="ХАРИУЦЛАГА"><br>
                        <p><span class="number">14.1.</span> Хэрэглэгчийн сонгосон захиалгын бүтээгдэхүүнүүд нь САЙТ-тай хамааралгүй БНХАУ-ын дэлгүүр, нийлүүлэгчийн бараа бүтээгдэхүүн тул тэдгээрийн чанар бусад үзүүлэлтүүдэд САЙТ хариуцлага хүлээхгүй.</p>
                        <p><span class="number">14.2.</span> Дэлгүүрийн найдвартай байдал, бараа бүтээгдэхүүний сонголт, чанартай холбоотой асуудлыг хэрэглэгч бүрэн хариуцна.</p>
                    </el-collapse-item>
                </el-collapse>
            </el-col>
        </el-row>
    </div>
</template>

<script>

export default {
  name: 'TermsOfService'
}
</script>

<style>
    .font_family {
        font-family: 'Geologica', sans-serif;
        text-align: center;
    }
    .number {
        display: inline-block; /* Дугаарыг бие даан байрлуулах */
        width: 30px; /* Дугаарын өргөнийг тохируулах */
        margin-right: 5px; /* Дугаарын ба текстийн хооронд зай нэмэх */
    }
    .text_justify {
        align-items: justify !important;
    }
    .el-collapse-item__header {
        padding: 5px 10px !important;
        line-height: 1.2 !important;
    }
    .el-collapse-item__header {
        /* background-color: #0c265c !important; */
        color: #000000 !important;
        padding: 10px;
        border-radius: 5px;
    }
    .el-collapse-item__header:hover {
        background-color: #007AFF !important;
        color: #ffffff !important;
    }
</style>
